import { render, staticRenderFns } from "./TalentConcept.vue?vue&type=template&id=0d7f1b1a"
import script from "./TalentConcept.vue?vue&type=script&lang=js"
export * from "./TalentConcept.vue?vue&type=script&lang=js"
import style0 from "./TalentConcept.vue?vue&type=style&index=0&id=0d7f1b1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports